"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BILLABLEMETRIC_CODE_ENUM = void 0;
var BILLABLEMETRIC_CODE_ENUM;
(function (BILLABLEMETRIC_CODE_ENUM) {
    BILLABLEMETRIC_CODE_ENUM["ROWS"] = "ROWS";
    BILLABLEMETRIC_CODE_ENUM["IMPORTED_ROWS"] = "IMPORTED_ROWS";
    BILLABLEMETRIC_CODE_ENUM["REMOVE_BRANDING"] = "REMOVE_BRANDING";
    BILLABLEMETRIC_CODE_ENUM["IMAGE_IMPORT"] = "IMAGE_IMPORT";
    BILLABLEMETRIC_CODE_ENUM["ADVANCED_VALIDATORS"] = "ADVANCED_VALIDATORS";
    BILLABLEMETRIC_CODE_ENUM["TEAM_MEMBERS"] = "TEAM_MEMBERS";
    BILLABLEMETRIC_CODE_ENUM["AUTOMATIC_IMPORTS"] = "AUTOMATIC_IMPORTS";
    BILLABLEMETRIC_CODE_ENUM["FREEZE_COLUMNS"] = "FREEZE_COLUMNS";
    BILLABLEMETRIC_CODE_ENUM["MANUAL_ENTRY"] = "MANUAL_ENTRY";
    BILLABLEMETRIC_CODE_ENUM["DOWNLOAD_SAMPLE_FILE"] = "DOWNLOAD_SAMPLE_FILE";
    BILLABLEMETRIC_CODE_ENUM["MAX_RECORDS"] = "MAX_RECORDS";
    BILLABLEMETRIC_CODE_ENUM["REQUIRED_VALUES"] = "REQUIRED_VALUES";
    BILLABLEMETRIC_CODE_ENUM["DEFAULT_VALUES"] = "DEFAULT_VALUES";
    BILLABLEMETRIC_CODE_ENUM["FIND_AND_REPLACE"] = "FIND_AND_REPLACE";
    BILLABLEMETRIC_CODE_ENUM["RUNTIME_SCHEMA"] = "RUNTIME_SCHEMA";
    BILLABLEMETRIC_CODE_ENUM["DATA_SEEDING"] = "DATA_SEEDING";
    BILLABLEMETRIC_CODE_ENUM["APPEARANCE_CUSTOMIZATION"] = "APPEARANCE_CUSTOMIZATION";
    BILLABLEMETRIC_CODE_ENUM["TEXT_CUSTOMIZATION"] = "TEXT_CUSTOMIZATION";
})(BILLABLEMETRIC_CODE_ENUM = exports.BILLABLEMETRIC_CODE_ENUM || (exports.BILLABLEMETRIC_CODE_ENUM = {}));
